var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaCompetenze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.423,
    height: 17.33,
    viewBox: "0 0 17.423 17.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icona",
    d: "M3.42,7.626l4.206-4.2L6.247,2.042,4.32,3.97a.247.247,0,0,1-.35,0l-.35-.35a.247.247,0,0,1,0-.35L5.547,1.341,4.5.29a.991.991,0,0,0-1.4,0l-2.8,2.8a.991.991,0,0,0,0,1.4L3.42,7.626Zm12.14-3.65a1.5,1.5,0,0,0,0-2.123L14.146.439a1.5,1.5,0,0,0-2.123,0L10.584,1.877l3.537,3.537ZM9.877,2.584.6,11.864.01,15.222a.663.663,0,0,0,.768.767L4.136,15.4l9.279-9.279Zm5.832,8.92-1.051-1.051L12.731,12.38a.247.247,0,0,1-.35,0l-.35-.35a.248.248,0,0,1,0-.35l1.927-1.927L12.578,8.373l-4.206,4.2L11.5,15.709a.991.991,0,0,0,1.4,0l2.8-2.8a.991.991,0,0,0,0-1.4Z",
    transform: "translate(0.697 0.728)",
    fill: "none",
    stroke: "#4e4e4e",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaCompetenze);
export default __webpack_public_path__ + "static/media/icona_competenze.7d257b6aa3019f8c02e107c76da10dcf.svg";
export { ForwardRef as ReactComponent };